import { AppRoute, ConfigSettingsService, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';

@Injectable()
export class RegisterNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.INIT;

  constructor(private readonly configService: ConfigSettingsService) {
    super('REGISTER', 'menu.label.signup', AppRoute.Registration, 'a11y.link.registrieren');
  }

  public guard(): boolean {
    return this.configService.appSettings.supportedOAuthGrants.has('password');
  }
}
